// ref https://github.com/atomicobject/elegant-form-validation-react

export const RuleRunner = (field, name, ...validations) => {
  return (state) => {
    for (const v of validations) {
      if (v) {
        const errorMessageFunc = v(state[field], state)
        if (errorMessageFunc) {
          return { [field]: errorMessageFunc(name) }
        }
      } else {
        return null
      }
    }
    return null
  }
}

export const run = (state, runners) => {
  return runners.reduce((memo, runner) => {
    return Object.assign(memo, runner(state))
  }, {})
}
